module.exports = __webpack_public_path__ + "media/application/images/2018/icon-loading-f65d4ec738526526f790da8e8a9f69ac.png";